import { Outlet, useLocation } from "react-router-dom";
import MenuInferior from "../Menu inferior/MenuInferior";
import { useStoreHome } from "../../paginas/Home/useStoreHome"; 
import "./layout.css";

const LayoutConMenu = () => {
  const location = useLocation();
  const esSalidas = location.pathname === "/produccion-salidas";

  const deviceConsentimiento = useStoreHome((s) => s.deviceConsentimiento);
  const menuBloqueado = deviceConsentimiento !== "granted"; 

  return (
    <div className="layout">
      <div className={`contenido-principal ${esSalidas ? "scroll-activo" : ""}`}>
        <Outlet />
      </div>
      <MenuInferior ruta={location.pathname} disabled={menuBloqueado} />
    </div>
  );
};

export default LayoutConMenu;
